import { MuiMenu } from './menu'
import { MuiDialog } from './dialog'
import { MuiPopover } from './popover'
import { MuiPopper } from './popper'
import { MuiTooltip } from './tooltip'
import { MuiAlert } from './alert'
import { MuiDatePicker } from './date-picker'

export const components = {
  MuiMenu,
  MuiDialog,
  MuiPopover,
  MuiPopper,
  MuiTooltip,
  MuiAlert,
  MuiDatePicker,
}
